var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVillaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 25,
    viewBox: "0 0 49 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.8455 22.3092C6.8455 22.0764 7.03419 21.8877 7.26689 21.8877H7.8701V19.0314C7.67268 18.9979 7.47118 18.9766 7.26429 18.9766C6.22223 18.9766 5.28622 19.4205 4.62711 20.1264C4.36561 20.0663 4.09447 20.0313 3.81459 20.0313C1.81998 20.0313 0.203125 21.6483 0.203125 23.6431H6.8455V22.3092Z",
    fill: "#5CB192",
    fillOpacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7344 19.5937V21.879H40.9407C41.2392 21.879 41.4819 22.1217 41.4819 22.4202V23.6343H42.1807H47.3827C47.478 23.462 47.5326 23.2638 47.5326 23.0528C47.5326 22.3879 46.9936 21.8487 46.3288 21.8487C46.211 21.8487 46.0977 21.8664 45.9902 21.8979C45.9911 21.8833 45.9946 21.8693 45.9946 21.8545C45.9946 21.4791 45.6902 21.1747 45.3149 21.1747C45.2033 21.1747 45.0995 21.2042 45.0064 21.252C44.9821 20.5688 44.422 20.022 43.733 20.022C43.3877 20.022 43.0752 20.1597 42.8454 20.3825C42.3718 19.89 41.7077 19.582 40.9704 19.582C40.8907 19.5819 40.8122 19.5867 40.7344 19.5937Z",
    fill: "#5CB192",
    fillOpacity: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5452 22.1406H7.10156V23.6373H17.5452V22.1406Z",
    fill: "#5CB192",
    fillOpacity: 0.9
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.12394 21.8586H19.3103C19.3049 21.8438 19.3008 21.8282 19.3008 21.8115V14.8576C19.3008 14.7794 19.3643 14.7161 19.4425 14.7161H24.0762C24.1543 14.7161 24.2179 14.7796 24.2179 14.8576V21.8115C24.2179 21.8282 24.2136 21.8438 24.2084 21.8586H25.5814V23.6385H27.4478V14.1535C27.4478 14.0753 27.5114 14.0118 27.5896 14.0118H37.6404C37.7186 14.0118 37.7821 14.0753 37.7821 14.1535V23.6385H38.6065V22.4069C38.6065 22.1047 38.8524 21.8586 39.1547 21.8586H39.4957V12.5245H39.7789V21.8586H40.4767V12.5245H42.1186V10.0925H40.9621V6.75564C40.9621 6.67744 40.8988 6.61392 40.8204 6.61392H25.446L25.4445 1.93366H25.586H26.84V0H6.28125V12.5245H8.12394V21.8586ZM39.7743 6.89735H40.6784V10.0925H39.7743V6.89735ZM38.2093 6.89735H39.4911V10.0925H38.2093V6.89735ZM36.6442 6.89735H37.926V10.0925H36.6442V6.89735ZM35.079 6.89735H36.3608V10.0925H35.079V6.89735ZM33.5141 6.89735H34.796V10.0925H33.5141V6.89735ZM31.9489 6.89735H33.2307V10.0925H31.9489V6.89735ZM30.3839 6.89735H31.6657V10.0925H30.3839V6.89735ZM28.8188 6.89735H30.1006V10.0925H28.8188V6.89735ZM27.2538 6.89735H28.5356V10.0925H27.2538V6.89735ZM26.9706 6.89735V10.0925H25.4467L25.4458 6.89735H26.9706ZM12.7724 20.0004H10.3072V16.2917H12.7724V20.0004ZM12.7724 16.0084H10.3072V14.2581H12.7724V16.0084ZM15.6763 20.0004H13.0557V16.2917H15.6763V20.0004ZM15.6763 16.0084H13.0557V14.2581H15.6763V16.0084ZM18.4249 20.0004H15.9597V16.2917H18.4249V20.0004ZM18.4249 16.0084H15.9597V14.2581H18.4249V16.0084ZM25.444 9.80926L25.4454 10.0925H25.444V9.80926ZM9.73653 3.19181C9.73653 3.11361 9.80004 3.05009 9.87823 3.05009H14.087C14.1651 3.05009 14.2287 3.11343 14.2287 3.19181V9.80926H14.731V3.19181C14.731 3.11361 14.7945 3.05009 14.8727 3.05009H19.0815C19.1597 3.05009 19.2232 3.11343 19.2232 3.19181V9.80926H19.7257V3.19181C19.7257 3.11361 19.7892 3.05009 19.8674 3.05009H24.0762C24.1543 3.05009 24.2179 3.11343 24.2179 3.19181V10.0925H9.7369V3.19181H9.73653Z",
    fill: "#5CB192",
    fillOpacity: 0.9
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9354 14.8633H28.3008V15.5113H36.9354V14.8633Z",
    fill: "#5CB192",
    fillOpacity: 0.9
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5876 14.9961V21.8082C19.5876 21.8249 19.5833 21.8405 19.5781 21.8554H19.8708V15.4209C19.8708 15.3427 19.9343 15.2793 20.0125 15.2793H23.5131C23.5913 15.2793 23.6548 15.3429 23.6548 15.4209V21.8554H23.9475C23.9421 21.8405 23.938 21.8249 23.938 21.8082V14.9961H19.5876Z",
    fill: "#5CB192",
    fillOpacity: 0.9
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9354 16.9648H28.3008V17.8577H36.9354V16.9648Z",
    fill: "#5CB192",
    fillOpacity: 0.9
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9354 15.793H28.3008V16.6856H36.9354V15.793Z",
    fill: "#5CB192",
    fillOpacity: 0.9
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9354 18.1445H28.3008V19.0373H36.9354V18.1445Z",
    fill: "#5CB192",
    fillOpacity: 0.9
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9354 21.6719H28.3008V22.5645H36.9354V21.6719Z",
    fill: "#5CB192",
    fillOpacity: 0.9
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9354 19.3203H28.3008V20.2131H36.9354V19.3203Z",
    fill: "#5CB192",
    fillOpacity: 0.9
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9354 22.8477H28.3008V23.4957H36.9354V22.8477Z",
    fill: "#5CB192",
    fillOpacity: 0.9
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2149 23.6401H37.4981V14.2969H27.7305V23.6401H28.0137V14.7218C28.0137 14.6436 28.077 14.5801 28.1554 14.5801H37.0732C37.1514 14.5801 37.2149 14.6436 37.2149 14.7218V23.6401Z",
    fill: "#5CB192",
    fillOpacity: 0.9
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9354 20.5H28.3008V21.3928H36.9354V20.5Z",
    fill: "#5CB192",
    fillOpacity: 0.9
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0195 9.80777H18.945V3.33203H15.0195V9.80777ZM15.4445 3.7568H18.5203V9.38281H15.4445V3.7568Z",
    fill: "#5CB192",
    fillOpacity: 0.9
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0078 9.80777H23.9333V3.33203H20.0078V9.80777ZM20.4327 3.7568H23.5086V9.38281H20.4327V3.7568Z",
    fill: "#5CB192",
    fillOpacity: 0.9
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0195 9.80777H13.945V3.33203H10.0195V9.80777ZM10.4443 3.7568H13.5201V9.38281H10.4443V3.7568Z",
    fill: "#5CB192",
    fillOpacity: 0.9
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1556 22.1406C39.0093 22.1406 38.8906 22.2593 38.8906 22.4057V23.6373H41.2251V22.4231C41.2251 22.2671 41.0986 22.1406 40.9426 22.1406H39.1556Z",
    fill: "#5CB192",
    fillOpacity: 0.9
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2994 22.1406H23.5113H20.0105H17.8281V22.6766H25.2994V22.1406Z",
    fill: "#5CB192",
    fillOpacity: 0.9
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3697 21.8592V15.5664H20.1523V21.8592H23.3697ZM22.8707 18.7688C23.0044 18.7688 23.1127 18.8771 23.1127 19.0108C23.1127 19.1445 23.0044 19.2528 22.8707 19.2528C22.737 19.2528 22.6287 19.1445 22.6287 19.0108C22.6287 18.8771 22.737 18.7688 22.8707 18.7688Z",
    fill: "#5CB192",
    fillOpacity: 0.9
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2995 22.9609H17.8281V23.6383H25.2995V22.9609Z",
    fill: "#5CB192",
    fillOpacity: 0.9
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4034 23.918H0V24.9982H48.4034V23.918Z",
    fill: "#5CB192",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVillaIcon);
export default __webpack_public_path__ + "static/media/VillaIcon.4f2a351873e28de802f2bc6edcd10dfa.svg";
export { ForwardRef as ReactComponent };